// extracted by mini-css-extract-plugin
module.exports = {"home":"Home_home__2W2mC","title":"Home_title__3n9sk","categories":"Home_categories__3md1T","category":"Home_category__1nB0j"};